__turbopack_context__.v({
  "amount": "PricingPlans-module__vQSPCG__amount",
  "amountText": "PricingPlans-module__vQSPCG__amountText",
  "anchor": "PricingPlans-module__vQSPCG__anchor",
  "badge": "PricingPlans-module__vQSPCG__badge",
  "badgeMuted": "PricingPlans-module__vQSPCG__badgeMuted",
  "billPill": "PricingPlans-module__vQSPCG__billPill",
  "billPillRow": "PricingPlans-module__vQSPCG__billPillRow",
  "billed": "PricingPlans-module__vQSPCG__billed",
  "bullets": "PricingPlans-module__vQSPCG__bullets",
  "card": "PricingPlans-module__vQSPCG__card",
  "cardHead": "PricingPlans-module__vQSPCG__cardHead",
  "contact": "PricingPlans-module__vQSPCG__contact",
  "cornerRibbon": "PricingPlans-module__vQSPCG__cornerRibbon",
  "cta": "PricingPlans-module__vQSPCG__cta",
  "currentPlan": "PricingPlans-module__vQSPCG__currentPlan",
  "grid": "PricingPlans-module__vQSPCG__grid",
  "gridOrganization": "PricingPlans-module__vQSPCG__gridOrganization",
  "head": "PricingPlans-module__vQSPCG__head",
  "hero": "PricingPlans-module__vQSPCG__hero",
  "includes": "PricingPlans-module__vQSPCG__includes",
  "kicker": "PricingPlans-module__vQSPCG__kicker",
  "kickerRow": "PricingPlans-module__vQSPCG__kickerRow",
  "page": "PricingPlans-module__vQSPCG__page",
  "period": "PricingPlans-module__vQSPCG__period",
  "pillSave": "PricingPlans-module__vQSPCG__pillSave",
  "planTag": "PricingPlans-module__vQSPCG__planTag",
  "plans": "PricingPlans-module__vQSPCG__plans",
  "price": "PricingPlans-module__vQSPCG__price",
  "priceBlock": "PricingPlans-module__vQSPCG__priceBlock",
  "ribbonFace": "PricingPlans-module__vQSPCG__ribbonFace",
  "ribbonFold": "PricingPlans-module__vQSPCG__ribbonFold",
  "saveLine": "PricingPlans-module__vQSPCG__saveLine",
  "tabIcon": "PricingPlans-module__vQSPCG__tabIcon",
  "tabIconGroup": "PricingPlans-module__vQSPCG__tabIconGroup",
  "tabs": "PricingPlans-module__vQSPCG__tabs",
});
